<script lang="ts">
	interface Props {
		height?: string // Default height
		width?: string // Default width
		class?: string
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props()
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	fill="none"
	viewBox="0 0 48 48"
	{height}
	{width}
	class={className}
>
	<path
		d="M16.06 8L30.588 22.528C31.1373 23.0795 31.1373 23.9713 30.588 24.5228L16.06 39.0508"
		stroke="currentColor"
		stroke-width="4"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
